import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import {useMdrdStore} from "@/store/models/mdrd-store";
import {computed, ref} from "vue";
import {useFormaterStore} from "@/store/utility/formatter-store";

export const useHomeStore = defineStore(
    'home',
    () => {
        const selectedSambungan = ref(null);
        const daftarTunggakan = ref(null);
        const infoSambungan = ref(null);
        const isSearchSambunganLoading = ref(false);
        const isTunggakanLoading = ref(false);
        const isInfoSambunganLoading = ref(false);
        const computedSelectedSambungan = computed(() => {
            if (selectedSambungan.value === null) {
                return {
                    'nosbg': null, 'namalang': null, 'gol': null, 'rayon': null, 'wilayah': null, 'alamat': null
                }
            }

            return {
                'nosbg': selectedSambungan.value.nosbg,
                'namalang': selectedSambungan.value.namalang,
                'gol': selectedSambungan.value.gol,
                'rayon': selectedSambungan.value.rayon,
                'wilayah': selectedSambungan.value.wilayah,
                'alamat': selectedSambungan.value.alamat
            }
        });

        const computedTotalTagihan = computed(() => {
            if (daftarTunggakan.value === null) {
                return useFormaterStore().priceFormat(0);
            }
            if (daftarTunggakan.value.length === 0) {
                return useFormaterStore().priceFormat(0);
            }
            return useFormaterStore().priceFormat(daftarTunggakan.value.map((data) => calculateTotalBayar(data)).reduce((accumulator, currentValue) => accumulator + currentValue));
        });
        /*const dataSourceMdrdDataStore = ref(
            new DataSource({
                requireTotalCount: true,
                store: useMdrdStore().mdrdCustomStore,
                filter: ['nosbg', '=', '01033413'],
            })
        );*/

        /*const dataSourceMdrdDataStore = ref(
            new DataSource({
                requireTotalCount: true,
                store: useMdrdStore().mdrdOdataStore,
                filter: [['sts_bayar', '=', '0'],'and',['nosbg','=','01033413']],
            })
        );*/

        const dataSourceMdrd = ref(
            new DataSource({
                requireTotalCount: true,
                store: useMdrdStore().mdrdCustomStore,
                onLoadingChanged: (isLoading) => {
                    isTunggakanLoading.value = isLoading;
                }
            })
        );

        const dataSourceInfoSambungan = ref(
            new DataSource({
                requireTotalCount: true,
                store: useMdrdStore().infoSambunganCustomStore,
                onLoadingChanged: (isLoading) => {
                    isInfoSambunganLoading.value = isLoading;
                }
            })
        );

        const dataSourceSambungan = ref(
            new DataSource({
                requireTotalCount: true,
                store: useMdrdStore().sambunganCustomStore,
                onLoadingChanged: (isLoading) => {
                    isSearchSambunganLoading.value = isLoading;
                }
            })
        );

        function onSambunganItemClick(e) {
            selectedSambungan.value = e.itemData;
            daftarTunggakan.value = null;
            infoSambungan.value = null;

            useMdrdStore().setSelectedNomorSambungan(selectedSambungan.value.nosbg);

            useMdrdStore().mdrdCustomStore.clearRawDataCache();
            useMdrdStore().infoSambunganCustomStore.clearRawDataCache();

            dataSourceMdrd.value.load().then((data) => {
                daftarTunggakan.value = data;
            });

            dataSourceInfoSambungan.value.load().then((data, comleteResponse) => {
                if (comleteResponse.totalCount !== 0) {
                    infoSambungan.value = data[0];
                } else {
                    infoSambungan.value = null;
                }
            });

        }

        const renderItem = (itemData, itemIndex) => {
            const isEven = itemIndex % 2 === 0;
            const backgroundColor = isEven ? '#F0F0F0' : '#FFFFFF';

            return (
                <div style={`background-color: ${backgroundColor}`}>
                    {itemData.text}
                </div>
            );
        };

        function calculateTotalBayar(dataRekening) {
            const jumlahrp = dataRekening.jumlahrp;// rs.getInt("jumlahrp");
            const danamtr = dataRekening.danamtr;//  rs.getInt("danamtr");
            const ppn_danamtr = 0; // tidak dipakai, selalu kosongkan saja
            const biayaadm = dataRekening.biayaadm;// rs.getInt("biayaadm");
            const retribusi = dataRekening.retribusi;// rs.getInt("retribusi");
            const abonemen = dataRekening.abonemen;// rs.getInt("abonemen");
            const meterai = dataRekening.meterai;// rs.getInt("meterai");
            const denda1 = dataRekening.denda;// rs.getInt("denda");
            const denda2 = dataRekening.segel;// rs.getInt("segel");
            const denda3 = dataRekening.cabut;// rs.getInt("cabut");

            return jumlahrp
                + danamtr
                + ppn_danamtr
                + biayaadm
                + retribusi
                + abonemen
                + meterai
                + denda1
                + denda2
                + denda3;
        }

        const openGoogleMaps = () => {

            const latitude = infoSambungan.value.latitude;
            const longitude = infoSambungan.value.longitude;

            const googleMapsLink = `https://www.google.com/maps?q=${latitude},${longitude}`;
            window.open(googleMapsLink, '_blank');
        }
        const makePhoneCall = () => {
            const phoneNumber = infoSambungan.value.telepon;
            const phoneCallLink = `tel:${phoneNumber}`;
            window.open(phoneCallLink, '_blank');
        }

        return {
            dataSourceMdrd,
            renderItem,
            dataSourceSambungan,
            selectedSambungan,
            onSambunganItemClick,
            computedSelectedSambungan,
            isSearchSambunganLoading,
            daftarTunggakan,
            calculateTotalBayar,
            computedTotalTagihan,
            dataSourceInfoSambungan,
            infoSambungan,
            openGoogleMaps, makePhoneCall,isInfoSambunganLoading
        }
    }
);